import { StageQuestionsService } from './../../stages/stage-questions.service';
import { EnrollmentProgramsService } from './../services/enrollment-programs.service';
import { AppSettings } from 'app/shared/app-settings';
import { HttpClient } from '@angular/common/http';
import { FormControl } from '@angular/forms';
import { SelectListItemModel } from './select-list-item.model';
import { Observable } from 'rxjs/Observable';
import { QuestionBaseModel } from './question-base.model';
import { MatAutocompleteSelectedEvent } from '@angular/material';

export class SchoolsAutocompleteModel extends QuestionBaseModel<number>{

    filteredOptions: Observable<SelectListItemModel[]>;
    private control:FormControl;
    private options:SelectListItemModel[]=[];
    
    constructor(options: {} = {}) {
        super(options);
    }

    filter(val: string): SelectListItemModel[] {
        return this.options.filter(option =>
          option.name.toLowerCase().indexOf(val.toLowerCase())>=0).slice(0,100);
     }
   
    loadSchoolOptions(service:StageQuestionsService) {
        service.loadSchoolOptions().subscribe(data=>{
            this.options=data.map(i=>new SelectListItemModel(i.aliases?`${i.name} (${i.aliases})`:i.name,i.name,null));
        })
    }

    setControlRef(control:FormControl){
        this.control=control;
        this.filteredOptions=this.control.valueChanges
            .map(val => val ? this.filter(val) : this.options.slice(0,100));
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/models/schools-autocomplete.model.ts